import { JetSportBox } from "../../components/BoxView/JetSportBox";
import { BoxHeader2 } from "../../components/BoxView/BoxHeader2";
import { BoxContent } from "../../components/BoxView/BoxContent";
import { OrderDoneCelebration } from "./subcomponents/OrderDoneCelebration";
import { BoxHeaderTypography } from "../../components/Typographies/BoxHeaderTypography";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

export function OrderPlaced() {
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get("orderNumber");

  const navigate = useNavigate();
  function handleNavigateToOrders() {
    navigate("/order");
  }

  return (
    <JetSportBox>
      <BoxHeader2>
        <BoxHeaderTypography className={"uppercase"}>
          Order confirmed
        </BoxHeaderTypography>
      </BoxHeader2>
      <BoxContent className={"pt-12 pb-32 items-center"}>
        <OrderDoneCelebration
          orderId={orderNumber ?? ""}
          handleNavigateToOrders={handleNavigateToOrders}
          showCustomerFillMessage={false}
        />
      </BoxContent>
    </JetSportBox>
  );
}
